import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { guaranteesFaq } from '@/mocks/strategix';

export default function GuaranteesFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="relative w-full px-5 md:px-10 py-20 md:py-28 bg-background-100/40 border-t border-background-200/70">
      <div className="max-w-3xl mx-auto">
        <SectionHeading
          label="Частые вопросы"
          title="Отвечаем на вопросы о гарантиях"
          description="Собрали ответы на вопросы, которые чаще всего задают клиенты перед стартом. Если не нашли свой — напишите нам, расскажем подробнее."
        />

        <div className="mt-12 space-y-3">
          {guaranteesFaq.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <Reveal key={item.question} delay={index * 50}>
                <div className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden">
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer transition-colors hover:bg-background-100/60"
                  >
                    <span className="font-heading text-sm md:text-base text-foreground-950">
                      {item.question}
                    </span>
                    <span
                      className={`w-7 h-7 flex-none flex items-center justify-center rounded-md bg-primary-500/10 text-primary-400 transition-transform duration-300 ${
                        isOpen ? 'rotate-45' : ''
                      }`}
                    >
                      <i className="ri-add-line text-base"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}